<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <v-dialog
    v-model="realValue"
    :fullscreen="$vuetify.breakpoint.mobile"
    max-width="800px"
  >
    <v-card
      :tile="$vuetify.breakpoint.mobile"
    >
      <div class="pa-6">
        <div class="d-flex align-center">
          <div>
            <div class="text-h4 font-weight-medium">
              {{ $t('DiscountAndRefund') }}
            </div>
            <div class="text-body-2">
              {{ $t('DiscountAndRefundHint') }}
            </div>
          </div>
          <v-spacer />

          <v-btn
            icon
            large
            @click="realValue=false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card
          class="d-flex mt-4"
          color="#f6f6f6"
          elevation="0"
          style="width: min-content"
        >
          <v-card
            :color="tabIndex===0?'amber lighten-4':'transparent'"
            class="pa-2 px-4 text-no-wrap"
            elevation="0"
            @click="tabIndex=0"
          >
            <v-icon left>
              mdi-archive-cancel
            </v-icon>
            {{ $t('ReturnFood') }}
          </v-card>
          <v-card
            :color="tabIndex===1?'amber lighten-4':'transparent'"
            class="pa-2 px-4 text-no-wrap"
            elevation="0"
            @click="tabIndex=1"
          >
            <v-icon left>
              mdi-percent-box-outline
            </v-icon>
            {{ $t('discount') }}
          </v-card>
        </v-card>
        <div class="my-4" />
        <div
          :style="!$vuetify.breakpoint.mobile ? 'max-height: 50vh' : 'max-height: 100vh'"
          style="overflow-y: scroll"
        >
          <template v-if="tabIndex===0">
            <v-data-table
              :headers="returnHeader"
              :items="returnList"
              @click:row.self="item=>showOrderDetail(item.orderId)"
            >
              <template #item.time="{item}">
                <div>
                  {{ item.time | beautifulTime }}
                </div>
              </template>
            </v-data-table>
          </template>
          <template v-else>
            <v-data-table
              :headers="discountHeader"
              :items="discountList"
              @click:row.self="item=>showOrderDetail(item.id)"
            >
              <template #item.time="{item}">
                <div>
                  {{ item.time | beautifulTime }}
                </div>
              </template>
              <template #item.value="{item}">
                <div>
                  {{ item.value | priceDisplay }}
                </div>
              </template>
            </v-data-table>
          </template>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from '@/i18n'
import { mapMutations } from 'vuex'
import { getFlattenedArray } from '@/model/dataLayer/service/MultipleStores'

export default {
  name: 'ReturnAndDiscountDialog',
  props: {
    realInfo: {},
    value: {},
    info: {}
  },
  data: function () {
    return {
      realValue: false,
      tabIndex: 0,
      discountHeader: [
        {
          value: 'name',
          text: i18n.t('tableNumber')
        }, {
          value: 'servantName',
          text: i18n.t('Waiter')
        }, {
          value: 'time',
          text: i18n.t('time')
        },
        {
          value: 'value',
          text: i18n.t('DiscountAmount')
        }
      ],
      returnHeader: [
        {
          value: 'name',
          text: i18n.t('tableNumber')
        },
        {
          value: 'servantName',
          text: i18n.t('Waiter')
        }, {
          value: 'time',
          text: i18n.t('time')
        }, {
          value: 'Dname',
          text: i18n.t('dishName')
        },
        {
          value: 'returnReason',
          text: i18n.t('returnReason')
        }
      ],
      showDetail: false,
      currentOrderId: null
    }
  },
  computed: {
    returnList () {
      return getFlattenedArray(this.realInfo, 'stornoList')
    },
    discountList () {
      return getFlattenedArray(this.realInfo, 'discountList')
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        this.realValue = val
      }
    },
    realValue (val, old) {
      if (val !== old) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    ...mapMutations(['showBillDetail']),
    showOrderDetail (id) {
      if (id.includes('|')) {
        id = id.split('|')[1]
      }
      this.showBillDetail(id)
    }
  }
}
</script>

<style scoped>

</style>
